const env = process.env.NODE_ENV
let envObj = {}

if (env === 'production') {
  envObj = {
    baseUrl: 'https://api-xl9-ssl.xunlei.com/tube',
    movieUrl: 'https://m.movie.xunlei.com'
  }
} else if (env === 'development') {
  envObj = {
    baseUrl: 'https://api-xl9-ssl.xunlei.com/tube',
    movieUrl: 'https://m.movie.xunlei.com'
  }
}
export default envObj
